import { action, observable } from 'mobx';

export interface IContainerWithSideBarProps {
  title: string;
  navigation: any;
  isCollapsed?: boolean;
  children: any;
  tab: string;
  collapseMenuClass?: string;
  setCollapsed: any;
}

// ********************************************* Separator *********************************************
export abstract class SeparatorVM {
  @observable props: any;

  // Abstract implementation
  protected abstract profileStoreRef?;
  protected abstract tableStoreRef?;
  protected abstract handleMouseUpResizeActions(data): Promise<void>;

  constructor(props) {
    this.props = props;
  }

  @observable containerDiv: string = 'design-container'; // 'separator-container';
  @observable resizableElement: string = 'separator-top-container';
  @observable separator: string = 'separator';

  private resizeWatchHandler;

  private handleMouseDownResize = (e) => {
    const resizableElement = document.getElementById(this.resizableElement);
    const containerDiv = document.getElementById(this.containerDiv);
    const currentViewExtent = this.profileStoreRef?._profileView?.extent;

    if (resizableElement && containerDiv) {
      const rect = resizableElement.getBoundingClientRect();
      const container = containerDiv.getBoundingClientRect();
      const minHeight = 20;
      const startHeight = rect.height;
      const startY = e.clientY;
      const maxHeight = container.height - 210;
      const handleMouseMoveResize = (e) => {
        document.body.style.userSelect = 'none';
        const deltaY = e.clientY - startY;
        const height = startHeight + deltaY;
        if (height > minHeight && height < maxHeight) {
          resizableElement.style.height = height + 'px';
          resizableElement.style.minHeight = height + 'px';
          resizableElement.style.maxHeight = height + 'px';
        }
      };
      const handleMouseUpResize = async () => {
        window.removeEventListener('mousemove', handleMouseMoveResize);
        window.removeEventListener('mouseup', handleMouseUpResize);
        document.body.style.userSelect = 'auto';
        await this.handleMouseUpResizeActions(currentViewExtent);
      };
      window.addEventListener('mousemove', handleMouseMoveResize);
      window.addEventListener('mouseup', handleMouseUpResize);
    }
  };

  private windowResizeWatchHandler;

  private handleWindowResize = (e) => {
    const resizableElement = document.getElementById(this.resizableElement);

    if (resizableElement) {
      const actionsOnWindowResize = (e) => {
        window.removeEventListener('resize', actionsOnWindowResize);
        resizableElement.style.height = '';
        resizableElement.style.minHeight = '';
        resizableElement.style.maxHeight = '';
      };
      window.addEventListener('resize', actionsOnWindowResize);
    }
  };

  @action.bound async onMount() {
    const separator = document.getElementById(this.separator);
    if (separator) {
      this.resizeWatchHandler = separator!.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
      this.windowResizeWatchHandler = window.addEventListener('resize', this.handleWindowResize.bind(this));
    }
  }

  @action.bound unMount() {
    this.resizeWatchHandler?.remove();
    this.windowResizeWatchHandler?.remove();
  }

  @action.bound removeHeights = () => {
    const resizableElement = document.getElementById(this.resizableElement);
    if (resizableElement) {
        resizableElement.style.height = '';
        resizableElement.style.minHeight = '';
        resizableElement.style.maxHeight = '';
    }
  }
}
